import { useEffect, useState } from 'react';
import axios from 'axios';
import './App.css';


function App() {
  const [data, setData] = useState({ results: [] });
  const [query, setQuery] = useState('');
  const [search, setSearch] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setSearch(query);
  };




useEffect(() => {
    const fetchCharacter = async () => {
      try {
        const result = await axios(
          `https://rickandmortyapi.com/api/character/?name=${search}`
        );
        setData(result.data);
      } catch (error) {
        setData({ results: [] });
        console.error("Error fetching data:", error);
      }
    };

    fetchCharacter();
  }, [search]); 

  return (
    <div className="app">
      <header>
        <h1 className='title'>
          Rick and Morty
        </h1>
        
  </header>

      <form onSubmit={handleSubmit}>
        <input className='Search'
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Buscar personagem"
        />
        <button type="submit">Buscar</button>
      </form>
    
      <div className="results">
        <ul>
          {data.results.map((item) => (
            <li key={item.id}>
              <img alt={item.name} src={item.image} />
              <h1 className='name'>{item.name}</h1>
              <p className='status'>Status: {item.status}</p>
              <p className='species'>Sua Espécie: {item.species}</p>
            </li>
          ))}
        </ul>
      </div>

<footer className="footer">
  <h1>Desenvolvido por Eduardo Costa</h1>

  <div className="links">
    <a href="https://github.com/devduduzinho" target="_blank" rel="noreferrer">
      GitHub
    </a>

    <a href="https://www.linkedin.com/in/eduardo-cost4/" target="_blank" rel="noreferrer">
      LinkedIn
    </a>

    <a href="https://www.instagram.com/eduardo_cost4/" target="_blank" rel="noreferrer">
      Instagram
    </a>
  </div>

  <p>© 2026 Rick and Morty Fan Page</p>
</footer>

    </div>
  );
}

export default App;